<template>
  <div class="related-personnel-box">
    <van-collapse v-model="activeNames">
      <van-collapse-item title="相关处置人员" name="1">
        <div class="divider"></div>
        <div v-for="(item, index) in personList" :key="index" class="people-item">
          <div class="info">
            <span class="address">{{ item.optMechanismName }}</span>
            <span class="name">{{ item.optName }}</span>
          </div>
          <a class="call-icon" @click="util.callConfirm('拨打该电话？', item.optContactTel, 6)" href="javascript:void(0)"></a>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!-- <step-info :historyInfo="historyInfo" :detail="detailInfo" class="step-info" ref="stepinfo"></step-info> -->

    <div class="step-box">
      <div class="step-item" :class="{'noborder': index === historyInfo.length - 1}" v-for="(item, index) in historyInfo" :key="index">
        <van-icon v-if="index !== 0" class="success-icon" color="#4cbb83" name="passed" />
        <div v-else class="curren-icon">
          <div></div>
        </div>
        <div v-if="item.creatTime" class="step-content">
          <div class="result">
            <span class="title">{{ item.optText }}</span>
            <span @click="toDetail(item, index)" v-if="showView(item)" class="view" >{{ '查看' }}</span>
            <van-icon v-if="showView(item)" class="arrow-icon" color="#36b374" name="arrow" />
          </div>

          <div v-if="item.optText === '退货单已评价'">
            <p class="result-item">
              <span class="address">退货人</span>
              <span class="name">{{ detailInfo.submitUser | nameFilter}}</span>
            </p>
            <p class="result-item">
              <span class="address">评价情况</span>
              <span class="Evaluation">{{ getEvaluation() }}</span>
              <img v-if="getEvaluation() === '不满意'" class="emo-icon" src="../../../../assets/refund/bumanyi.png" alt="">
              <img v-if="getEvaluation() === '基本满意'" class="emo-icon" src="../../../../assets/refund/jibenmanyi.png" alt="">
              <img v-if="getEvaluation() === '满意'" class="emo-icon" src="../../../../assets/refund/manyi.png" alt="">
            </p>
          </div>

          <div v-else-if="item.optText === '已反馈取货结果'">
            <!-- 如果是邮寄退货 -->
            <template v-if="refundType() == 1">
              <p class="result-item">
                <span class="address">处置机构</span>
                <span class="name">{{ item.optMechanismName }}</span>
              </p>
              <p class="result-item">
                <span class="address">处置人员</span>
                <span class="name">{{ item.optName }}</span>
              </p>
            </template>
            <!-- 如果是现场退货 -->
            <template v-else>
              <p class="result-item">
                <span class="address">协助处置机构</span>
                <span class="name">{{ item.optMechanismName }}</span>
              </p>
              <p class="result-item">
                <span class="address">协助处置人员</span>
                <span class="name">{{ item.optName }}</span>
              </p>
            </template>
          </div>

          <div v-else-if="item.optText === '已签订《委托存放协议》'">
            <p class="result-item">
              <span class="address">协助处置机构</span>
              <span class="name">{{ entrustment.signOrgName }}</span>
            </p>
            <p class="result-item">
              <span class="address">协助处置人员</span>
              <span class="name">{{ assistDisposer }}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '退货单已发起'">
            <p class="result-item">
              <span class="address">退货人</span>
              <span class="name">{{ item.optMechanismName | nameFilter }}</span>
            </p>
            <p class="result-item">
              <span class="address">退货原因</span>
              <span class="name">{{ item.reason }}</span>
            </p>
          </div>
          

          <div v-else-if="item.optText === '审核通过' || item.optText === '审核不通过'">
            <p class="result-item">
              <span class="address">审核机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">审核人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
            <p class="result-item">
              <span class="address">审核意见</span>
              <span class="name">{{ item.memo }}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '已上报'">
            <p class="result-item">
              <span class="address">上报机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">上报人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
            <p class="result-item">
              <span class="address">上报原因</span>
              <span class="name">{{ item.memo }}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '已转办'">
            <p class="result-item">
              <span class="address">转办机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">转办人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
            <p class="result-item">
              <span class="address">转办要求</span>
              <span class="name">{{ item.memo }}</span>
            </p>
          </div>

           <div v-else-if="item.optText === '已退回'">
            <p class="result-item">
              <span class="address">处置机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">处置人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
            <p class="result-item">
              <span class="address">退回原因</span>
              <span class="name">{{ getReasonReturn(item) }} - {{ item.memo }}</span>
            </p>
          </div>

           <div v-else-if="item.optText === '已重新提交'">
            <p class="result-item">
              <span class="address">退货人</span>
              <span class="name">{{ detailInfo.submitUser | nameFilter }}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '待重新提交'">
            <p class="result-item">
              <!-- <span class="address">处置机构</span> -->
              <span class="name">[退货人]{{ detailInfo.submitUser | nameFilter }} 待重新提交...</span>
            </p>
          </div>

          <div v-else-if="item.optText === ''">
            <p class="result-item">
              <!-- <span class="address">处置机构</span> -->
              <span class="name">[退货人]{{ detailInfo.submitUser | nameFilter }} 待重新提交...</span>
            </p>
          </div>

          <div v-else-if="item.optText === '不予受理'">
            <p class="result-item">
              <span class="address">处置机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">处置人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
            <p v-if="item.wherefore" class="result-item">
              <span class="address">不予受理原因</span>
              <span class="name">{{ getReasonsInadmissibility(item) }}</span>
            </p>
            <p class="result-item">
              <span class="address">补充说明</span>
              <span class="name">{{ item.memo || '无'}}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '游客撤销'">
            <p class="result-item">
              <span class="address">退货人</span>
              <span class="name">{{ detailInfo.submitUser | nameFilter }}</span>
            </p>
            <p class="result-item">
              <span class="address">撤销原因</span>
              <span class="name">{{ getReasonReturn(item) }}</span>
            </p>
            <p class="result-item">
              <span class="address">补充说明</span>
              <span class="name">{{ item.memo }}</span>
            </p>
          </div>

           <div v-else-if="item.optText === '游客已收货'">
            <p class="result-item">
              <span class="address">退货人</span>
              <span class="name">{{ detailInfo.submitUser | nameFilter }}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '游客申诉'">
            <p class="result-item">
              <span class="address">退货人</span>
              <span class="name">{{ detailInfo.submitUser | nameFilter }}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '退货方式变更'">
            <p class="result-item">
              <span class="address">处置机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">处置人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
            <p class="result-item">
              <span class="address">变更内容</span>
              <span class="name">退货方式由{{ item.optContent | filterOptContent }}</span>
            </p>

            <p class="result-item">
              <span class="address">补充说明</span>
              <span class="name">{{ item.memo }}</span>
            </p>
          </div>

          <div v-else-if="item.optText === '待受理'">
            <p class="result-item">
              <span class="address">{{ item.optMechanismName }}已响应...</span>
            </p>
          </div>

          <div v-else-if="item.optText === '待响应'">
            <p class="result-item">
              <span class="address">{{ item.optMechanismName }}待响应...</span>
            </p>
          </div>

          <div v-else-if="item.optText === '已反馈快递单号'">
            <template v-if="item.optMechanismName">
              <p class="result-item">
                <span class="address">处置机构</span>
                <span class="name">{{ item.optMechanismName }}</span>
              </p>
              <p class="result-item">
                <span class="address">处置人员</span>
                <span class="name">{{ item.optName }}</span>
              </p>
            </template>
            <template v-else>
              <p class="result-item">
                <span class="address">退货人</span>
                <span class="name">{{ detailInfo.submitUser | nameFilter }}</span>
              </p>
            </template>
          </div>

          <div v-else-if="item.optText === '已发起《委托存放协议》'">
            <p class="result-item">
              <span class="address">协助处置机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">协助处置人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
          </div>

          <div v-else>
            <p class="result-item">
              <span class="address">处置机构</span>
              <span class="name">{{ item.optMechanismName }}</span>
            </p>
            <p class="result-item">
              <span class="address">处置人员</span>
              <span class="name">{{ item.optName }}</span>
            </p>
          </div>

        </div>
        <div v-else class="step-content">
          <div class="result">
              <span class="title">{{ item.optText }}</span>
          </div>
          <p v-if="item.optContent" class="result-item">
              <span class="address">{{ item.optContent }}...</span>
          </p>
        </div>
        <div v-if="item.creatTime" class="time">{{ item.creatTime | timefilt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
    // import stepInfo from '../refundDetail/stepInfo';
    import util from '../../../../utils/common'
    import api from '../../../../service/modules/refund'

    export default {
        components: {
            // stepInfo
        },
        name: 'disposalProgressDetail',
        filters: {
            filterOptContent (val) {
              if (val) {
                const arr = val.split('】')
                return `${arr[0]}】${arr[1]}】`
              }
            },
            timefilt (val) {
                return util.getStampInDate2(val, '/');
            },
            // 姓名脱敏
            nameFilter(val) {
              let newName = val.substr(0, 1)
              const strLength = val.length - 1
              for(let i = 0; i < strLength; i++) {
                newName += '*'
              }
              return newName
            }
        },
        async created () {
          this.init()
        },
        activated() {
          this.init()
          this.flowid = this.$route.query.flowid;
          this.haveSeeDisposalprogressHandle()
        },
        data () {
            return {
                flowid: 0,
                activeNames: [],
                historyInfo: [], // 处置进度
                personList: [], // 处置人员列表
                detailInfo: {}, // 退货单详情
                REFUND_REASON: [], // 退货原因
                WHEREFORE: [], // 不予受理原因
                evaluations: [], // 评价情况
                WHEREFORE_ALL: [],
                protocol: '',
                expressList: [], // 快递信息
                entrustment: {},
                assistDisposer: ''
            };
        },
        methods: {
          async init() {
            this.getAssistDisposer()
            await this.getType()
            this.historyInfo = JSON.parse(this.$route.query.historyInfo);
            this.detailInfo = JSON.parse(this.$route.query.detailInfo);
            console.log('detailInfo', this.detailInfo)
            this.historyInfo.push({
                optText: '退货单已发起',
                optMechanismName: this.detailInfo.submitUser,
                reason: this.getRefundReason(this.detailInfo.refundReason),
                creatTime: this.detailInfo.refundTime
            })
            this.flowid = this.$route.query.flowid;
            this.getOrderDetail()
            this.relatedDisposalPersonnel();
            let index = 0
            this.historyInfo.map(item => {
                if (item.optText === '退货方式变更') {
                    item.change = item.optContent.match(/(\S*)\s/)[1]
                }
                // 给申诉节点添加索引，用于详情页的时候区别
                if (item.optText == '申诉已反馈' || item.optText == '游客申诉') {
                    item.appealListIndex = index
                    index += 1
                }
            })
            if (this.$store.state.refund.detail.entrustment) {
                this.protocol = this.$store.state.refund.detail.entrustment.entrustmentUrl
            }
          },
          // 是否进入过处置进度详情
          haveSeeDisposalprogressHandle() {
            let seeDisposalprogressFlowid = localStorage.getItem('seeDisposalprogressFlowid') // 已经进入过处置进度详情的退货单
            if (!seeDisposalprogressFlowid) {
              // 如果没有存到过本地,新建数组保存已经进入过处置进度详情的退货单
              const arr = [this.flowid]
              localStorage.setItem('seeDisposalprogressFlowid', JSON.stringify(arr))
              this.activeNames.push('1')
            } else {
              // 否则判断当前退货单是否已经进入过处置进度详情
              let a = JSON.parse(localStorage.getItem('seeDisposalprogressFlowid'))
              const index = a.indexOf(this.flowid)
              if (index === -1) {
                // 如果没进入过处置进度详情，则打开相关处置人员,并记录下来
                this.activeNames.push('1')
                a.push(this.flowid)
                localStorage.setItem('seeDisposalprogressFlowid', JSON.stringify(a))
              } else {
                // 如果已经进入过就收起
                this.activeNames = []
              }
            }
          },
          refundType() {
            return this.detailInfo.finalRefundTypes || this.detailInfo.refundType
          },
            getAssistDisposer () {

            },
            // 查看详情
            toDetail (item, index) {
                const optText = item.optText
                switch (optText) {
                case '已同意受理':
                    this.$router.push({
                        path: '/refund/agreeAcceptDetail'
                    });
                    break;
                case '已反馈取货结果':
                    this.$router.push({
                        path: '/refund/pickupInformationDetails'
                    });
                    break;
                case '退货单已评价':
                    this.$router.push({
                        path: '/refund/evaluationDetails',
                        query: {
                            flowId: this.flowid
                        }
                    });
                    break;
                case '已签订《委托存放协议》':
                    window.location.href = this.protocol
                    break;

                case '已发起《委托存放协议》':
                window.location.href = this.protocol
                    break;

                case '已反馈寄件地址':
                    this.$router.push({
                        path: '/refund/returnAddress'
                    });
                    break;
                case '已反馈处置结果':
                    this.$router.push({
                        path: '/refund/feedbackDisposalResultsDetail',
                        query: {
                            item: JSON.stringify(item),
                            historyIndex: index
                        }
                    });
                    break;
                case '已审核处置结果':
                    this.$router.push({
                        path: '/refund/feedbackDisposalResultsDetail',
                        query: {
                            item: JSON.stringify(item),
                            historyIndex: index

                        }
                    });
                    break;
                case '已反馈快递单号':
                    this.$router.push({
                        path: '/refund/logistics',
                        query: {
                            data: this.detailInfo,
                            flowId: this.flowid,
                            addressInfo: this.expressList
                        }
                    });
                    break;
                case '申诉已反馈':
                    this.$router.push({
                        path: '/refund/appealDetails',
                        query: {
                            appealListIndex: item.appealListIndex,
                            item: item
                        }
                    });
                    break;
                case '游客申诉':
                    this.$router.push({
                        path: '/refund/appealDetails',
                        query: {
                            appealListIndex: item.appealListIndex,
                            item: item

                        }
                    });
                    break;
                default: console.log('都不是');
                }
            },
            getType () {
                return new Promise((resolve, reject) => {
                    api.typePicker().then(res => {
                        if (res.ret === 0) {
                            this.REFUND_REASON = res.data.REFUND_REASON
                            this.WHEREFORE = res.data.WHEREFORE
                            this.WHEREFORE_ALL = res.data.WHEREFORE_ALL
                        }
                        resolve()
                    })
                })
            },
            // 获取退回原因
            getReasonReturn (item) {
                if (this.WHEREFORE_ALL.length > 0) {
                    return (this.WHEREFORE_ALL.find(i => i.code === item.wherefore) || {}).name
                }
            },
            // 获取不予受理原因
            getReasonsInadmissibility (item) {
                const val = item.wherefore
                let txt = ''
                if (this.WHEREFORE.length > 0) {
                    this.WHEREFORE.map(i => {
                        if (i.code === val) {
                            txt = i.name
                        }
                    })
                }
                return txt
            },
            // 查看按钮显示隐藏控制
            showView (item) {
                const option = ['申诉已反馈', '已发起《委托存放协议》', '游客申诉', '', '退货单已评价', '已反馈处置结果', '已反馈取货结果', '已签订《委托存放协议》', '已同意受理', '已反馈寄件地址', '已审核处置结果', '已反馈快递单号', '', '', '', '']
                if (item.optText == '已反馈取货结果') {
                    return this.detailInfo.finalRefundTypes === 2
                } else {
                    return option.includes(item.optText)
                }
            },
            getRefundReason (val) {
                let txt = ''
                console.log('REFUND_REASON', this.REFUND_REASON)
                if (this.REFUND_REASON.length > 0) {
                    this.REFUND_REASON.map(i => {
                        if (i.code === val) {
                            txt = i.name
                        }
                    })
                }
                return txt
            },
            // 获取退货单详情
            getOrderDetail () {
                api.detailList({ flowId: this.flowid }).then(res => {
                    if (res.ret === 0) {
                        this.evaluations = res.data.evaluations
                        this.expressList = res.data.expressList
                        this.entrustment = res.data.entrustment
                        const centerOrder = res.data.centerOrder
                        const obj = centerOrder.find(i => i.relType === 1)
                        if (obj) {
                            this.assistDisposer = obj.creatorName
                        }
                    }
                })
            },
            // 获取评价情况
            getEvaluation () {
                let txt = ''
                const option = {
                    1: '不满意',
                    3: '基本满意',
                    5: '满意'
                }
                if (this.evaluations.length > 1) {
                    this.evaluations.map(i => {
                        if (i.targetType === 1) {
                            txt = option[i.grade]
                        }
                    })
                }
                return txt
            },
            // 获取相关处置人员
            relatedDisposalPersonnel () {
                const newArr = []
                this.personList = this._.cloneDeep(this.historyInfo)
                console.log('----------', this.personList);
                this.personList = this.personList.filter(i => i.optContactTel)
                this.personList.map(i => {
                    const index = newArr.findIndex(item => i.optContactTel && (item.optContactTel === i.optContactTel));
                    const hasName = i.optMechanismName && i.optName;
                    if (index === -1 && hasName) {
                        newArr.push(i)
                    }
                })
                this.personList = newArr
            }
        }
    };
</script>
<style lang="less" scoped>
.related-personnel-box {
  padding: 20px 16px;
  .van-icon-arrow:before {
    font-size: 12px;
  }
  /deep/.van-collapse {
    margin-bottom: 40px;
    .van-cell {
      background-color: #f5f6f9;
      padding: 16px;
      font-size: 16px;
      color: #171a1d;
      border-radius: 4px;
    }
    .van-collapse-item__wrapper {
      .van-collapse-item__content {
        background-color: #f5f6f9;
        padding: 0 16px;
        border-radius: 0 0 4px 4px;
        .divider {
          border-top: 1px solid #eaedf4;
        }
        .people-item {
          padding: 13px 0;
          display: flex;
          justify-content: space-between;
          .info {
            display: flex;
            align-items: center;
            .address {
              font-size: 14px;
              color: #171a1d;
              min-width: 112px;
              display: inline-block;
              margin-right: 12px;
              font-weight: 400;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 170px;
            }
            .name {
              font-size: 14px;
              color: #71747a;
              font-weight: 400;
            }
          }
          .call-icon {
            width: 24px;
            height: 24px;
            background-image: url("../../../../assets/refund/icon_ts_dh@2x.png");
            background-size: 100%;
            background-repeat: no-repeat;
            border-radius: 50%;
            background-position: center;
          }
          // .call {
          //   background-color: #eaf7f1;
          //   width: 24px;
          //   height: 24px;
          //   display: flex;
          //   align-items: center;
          //   justify-content: space-around;
          //   border-radius: 50%;
          //   .call-icon {
          //     width: 11.4px;
          //     height: 11.4px;
          //     background-image: url("../../../../assets/refund/icon_callPhone.png");
          //     background-size: 100% 100%;
          //   }
          // }
        }
      }
    }
  }
  .step-box {
    .step-item {
      border-left: 1px solid #a5ddc1;
      padding-left: 17.5px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 48px;
      position: relative;
      .success-icon {
        position: absolute;
        font-size: 18px;
        top: -2px;
        left: 0;
        background: white;
        transform: translate(-50%);
      }
      .curren-icon {
        position: absolute;
        width: 18px;
        height: 18px;
        top: -2px;
        left: 0;
        transform: translate(-50%);
        background: #d7f0e4;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 50%;
        div {
          border-radius: 50%;
          background: #36b374;
          width: 10px;
          height: 10px;
        }
      }
      .step-content {
        min-width: 225px;
        .result {
          margin-bottom: 16px;
          .title {
            margin-right: 8px;
            vertical-align: super;
            font-weight: 600;
            font-size: 16px;
            color: #171A1D;
          }
          .view {
            font-size: 14px;
            color: #36b374;
            vertical-align: top;
            vertical-align: super;
          }
          /deep/.arrow-icon {
            vertical-align: top;
            font-size: 12px;
            line-height: 18px;
          }
        }
        .result-item {
          margin-bottom: 12px;
          display: flex;
          .emo-icon {
            width: 18px;
            height: 18px;
          }
          span {
            &:first-child {
              margin-right: 12px;
              font-weight: 400;
              font-size: 14px;
              color: #71747A;
              min-width: 56px;
              padding-top: 2px;
            }
            &:last-child {
              font-size: 14px;
              color: #171a1d;
              line-height: 19px;

            }
          }
          .Evaluation {
            font-size: 14px;
            color: #171a1d;
            line-height: 19px;
            margin-right: 5px;
          }
          .address {
            font-size: 14px;
              color: #171a1d;
              font-weight: 400;
          }
        }
      }
      .time {
        font-size: 12px;
        color: #a2a3a4;
        min-width: 64px;
        white-space: nowrap;
      }
    }
    .noborder {
      border-left: 0;
    }
  }
}
/deep/.step-info {
  padding: 0;
  .shadow {
    padding: 0;
    overflow: inherit;
    box-shadow: none;
    padding: 0;
  }
}
</style>
